module.exports = __webpack_public_path__ + "media/cards/Google-Pay-Mark-205fbb9f.png";